import { langStore } from "@/stores/lang-store"
import { summaryStore } from "./summary-store"
import { formatMessage } from "@/utils/format-message"
import Flex from "@/components/flex"
import { useSearchParams } from "react-router-dom"
import { summaryBundle } from "./summary-const"

const SummaryContent = () => {
  const { lang } = langStore()
  const [params] = useSearchParams()
  const dong = params.get("dong") ?? "O"
  const ho = params.get("ho") ?? "OOO"

  const { stats, meta } = summaryStore()

  const total = Number(stats?.total_count || 0)

  const myRank = typeof stats.rank === "number" ? stats.rank : null

  const percent = Math.abs(Number(stats?.percent || 0))

  const usage = Number(stats.value || 0)

  const average = Number(stats.group_mean || 0)

  const rankPercent = total > 0 && myRank ? ((myRank / total) * 100).toFixed(1) : 0

  const usageStatus = (() => {
    if (percent <= 5) {
      return {
        label: summaryBundle.avg,
        className: `
          bg-emerald-50
          text-emerald-600
          border-emerald-200
        `
      }
    }

    if (stats.percent > 0) {
      return {
        label: summaryBundle.high,
        className: `
          bg-red-50
          text-red-600
          border-red-200
        `
      }
    }

    return {
      label: summaryBundle.low,
      className: `
        bg-blue-50
        text-blue-600
        border-blue-200
      `
    }
  })()

  return (
    <section className="min-w-80 flex flex-col rounded-3xl p-2 py-6">
      <header className="mb-6">
        <p className="text-sm text-gray-400">
          {formatMessage(summaryBundle.info[lang], { dong, ho })}
        </p>

        <h2 className=" mt-1 text-3xl font-black tracking-tight text-gray-900">
          {usage.toLocaleString()}
          <span className="ml-1 text-lg font-semibold text-gray-400">{meta.unit}</span>
        </h2>

        <p className="mt-2 text-sm text-gray-500">
          {stats.percent >= 0
            ? formatMessage(summaryBundle.overuse[lang], { percent })
            : formatMessage(summaryBundle.underuse[lang], { percent })}
        </p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        <article className="rounded-2xl bg-gray-50 p-4">
          <p className="text-xs text-gray-400">{summaryBundle.groupAverage[lang]}</p>

          <strong
            className="mt-1 block
              text-xl font-bold
              text-gray-900
            "
          >
            {average.toLocaleString()}
          </strong>
        </article>

        <article className="rounded-2xl bg-gray-50 p-4">
          <p className="text-xs text-gray-400">{summaryBundle.rank[lang]}</p>

          <strong
            className="
              mt-1 block
              text-xl font-bold
              text-gray-900
            "
          >
            {myRank}
            <span
              className="
                ml-1 text-sm
                font-medium text-gray-400
              "
            >
              / {total}
            </span>
          </strong>
        </article>
      </div>

      {/* Rank Visual */}
      <section className="mt-6">
        <Flex className="mb-2 flex items-center justify-between" gap={0}>
          <span className="text-sm font-medium text-gray-500">{summaryBundle.usageRank[lang]}</span>

          <span className="text-sm font-bold text-indigo-600">TOP {rankPercent}%</span>
        </Flex>

        <div
          className="
            relative h-3
            overflow-hidden
            rounded-full
            bg-gray-100
          "
        >
          <div
            className="
              absolute left-0 top-0
              h-full rounded-full
              bg-indigo-500
              transition-all duration-500
            "
            style={{ width: `${rankPercent}%` }}
          />
        </div>
      </section>

      {/* Status */}
      <section className="mt-auto pt-6">
        <div
          className={`
            inline-flex items-center
            rounded-full border
            px-3 py-1
            text-sm font-semibold
            ${usageStatus.className}
          `}
        >
          {usageStatus.label[lang]}
        </div>
      </section>
    </section>
  )
}

export default SummaryContent
